module.exports = __webpack_public_path__ + "static/media/bliss-preto.37843963.webp";